import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createSuper";
import { Range } from "./Range";
import { getDistance } from "../../Utils/NumberUtils";
export var Circle = /*#__PURE__*/function (_Range) {
  _inherits(Circle, _Range);
  var _super = _createSuper(Circle);
  function Circle(x, y, radius) {
    var _this;
    _classCallCheck(this, Circle);
    _this = _super.call(this, x, y);
    _this.radius = radius;
    return _this;
  }
  _createClass(Circle, [{
    key: "contains",
    value: function contains(point) {
      return getDistance(point, this.position) <= this.radius;
    }
  }, {
    key: "intersects",
    value: function intersects(range) {
      var rect = range,
        circle = range,
        pos1 = this.position,
        pos2 = range.position,
        xDist = Math.abs(pos2.x - pos1.x),
        yDist = Math.abs(pos2.y - pos1.y),
        r = this.radius;
      if (circle.radius !== undefined) {
        var rSum = r + circle.radius,
          dist = Math.sqrt(xDist * xDist + yDist + yDist);
        return rSum > dist;
      } else if (rect.size !== undefined) {
        var w = rect.size.width,
          h = rect.size.height,
          edges = Math.pow(xDist - w, 2) + Math.pow(yDist - h, 2);
        if (xDist > r + w || yDist > r + h) {
          return false;
        }
        if (xDist <= w || yDist <= h) {
          return true;
        }
        return edges <= r * r;
      }
      return false;
    }
  }]);
  return Circle;
}(Range);